import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { deserialize } from 'santee-dcts';
import { Settings } from '../../../core';
import { AdminProtocolAccessReport, AdminProtocolAccessReportReadModel } from '../report-types/admin-activity-report-protocol-access';
import { defaultProtocolAccessesSort } from '../../../documents/models/default-report-sort';
import { Protocol } from '../../shared';

interface SearchValues {
    readonly email: object;
    readonly protocol: object;
}

@Injectable()
export class AdminProtocolAccessesStorage {
    constructor(
        private http: HttpClient,
        private settings: Settings
    ) { }

    public getReports(searchValues: SearchValues): Observable<AdminProtocolAccessReport[]> {

        let params = this.prepareSearchFieldsParams(searchValues);

        return this.http.get(`${this.settings.apiUrl}/admin/activity-reports/protocol-accesses`, { params: params })
            .pipe(
                map((reports) => {
                    let protocolAccesses = deserialize(reports, AdminProtocolAccessReportReadModel).reports;
                    protocolAccesses = protocolAccesses.sort((a, b) => defaultProtocolAccessesSort(a, b));
                    return protocolAccesses;
                }),
            );
    }

    private prepareSearchFieldsParams(searchValues: SearchValues): HttpParams {
        let httpParams = new HttpParams();

        if (searchValues.email) {
            httpParams = httpParams.append('email', searchValues.email.toString());
        }

        if (searchValues.protocol) {
            httpParams = httpParams.append('protocol', (searchValues.protocol as Protocol).id.toString());
        }

        return httpParams;
    }
}
